import { loadStripe } from "@stripe/stripe-js";
//for prod environment variable3

export async function getStripeJs() {
  const stripeJs = await loadStripe(
    //force git2
    process.env.REACT_APP_STRIPE_PUBLIC_KEY_PROD
    // process.env.REACT_APP_STRIPE_PUBLIC_KEY
  );

  return stripeJs;
}
